import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
export const EticketFooter = ({ mainWebShop }) => {
    const { t } = useTranslation(I18N_NAMESPACES.general);
    return (_jsxs(TextAlpha, { children: [t('eticket.footer'), _jsx("br", {}), t(`eticket.team.${mainWebShop}`)] }));
};
